import React from "react";
import styled from "styled-components";

import { Link, Image } from "@global";
import { animations, colors } from "@util/constants";
import { Container, GradientOverlay, P } from "@util/standard";
import { SanityNews } from "@graphql-types";

interface Props {
  data: SanityNews;
  isFeaturedArticle?: boolean;
}

const ArticleWrapper = styled(Container)<{ isFeaturedArticle?: boolean }>`
  width: 100%;
  height: 87vh;
  position: relative;
  color: ${colors.white};
  justify-content: flex-end;
  filter: grayscale(1);

  &:hover {
    filter: grayscale(0);
  }

  transition: all 0.2s;

  ${animations.fadeIn(0.2)};
`;

const ArticleTitle = styled.h2`
  max-width: 474px;
  margin-top: 40px;
`;

const StyledLink = styled(Link)<{ width?: string }>`
  width: 100%;
  ${({ width }) => width && `width: ${width};`};
  height: 87vh;
  div {
    text-decoration: none;
    &:visited {
      color: ${colors.white};
    }
  }
`;

const ArticlePreview = ({ data, isFeaturedArticle }: Props) => {
  const { title, gridItemImage, categories, date, region, slug } = data;

  const categoryName = categories && categories[0] && categories[0].title;
  return (
    <StyledLink internalLink={{ slug, region, _type: "news" }}>
      <ArticleWrapper>
        <Container
          width={isFeaturedArticle ? "82.5%" : "65%"}
          margin="auto"
          height="100%"
          padding="100px 0"
          justifyContent="space-between"
          flexDirection="column"
          zIndex={2}
        >
          <div>
            <Container justifyContent={isFeaturedArticle ? "space-between" : "flex-start"}>
              <P margin="0 10px 0 0">{date ?? ""}</P>
              <P>{categoryName ?? ""}</P>
            </Container>

            {!isFeaturedArticle && <ArticleTitle>{title}</ArticleTitle>}
          </div>
          <Container
            width={isFeaturedArticle ? "100%" : "max-content"}
            justifyContent={isFeaturedArticle ? "space-between" : "flex-start"}
            tabletFlexDirection="column"
          >
            {isFeaturedArticle && <ArticleTitle>{title}</ArticleTitle>}
            <Container
              height="100%"
              tabletMargin="20px 0 0 0"
              justifyContent="flex-end"
              flexDirection="column"
            >
              <Link
                linkText="Read More"
                internalLink={{ slug, region, _type: "news" }}
                design="outlineLight"
                useIcon="iconRightArrow"
                buttonSize="l"
              />
            </Container>
          </Container>
        </Container>
        {gridItemImage && <Image isBackground data={gridItemImage} />}
        <GradientOverlay gradient="primaryFade" />
      </ArticleWrapper>
    </StyledLink>
  );
};

export default ArticlePreview;
